import {scriptonload} from '../modules/scriptonload';

class UPlayerWrapper {
    constructor(el) {
        var self = this;

        this.status; /* если вдруг решим удалить объект, а он еще не загрузился */
        this.oUPlayer;

        if(!window.uPlayer){
            this.status = 'loading';
            scriptonload(APP.vendors.uPlayer, function(){self._init.call(self, el)});
        }
        else this._init(el);
    }

    _init(el){
        if(this.status === 'notload') return;
        this.oUPlayer = uPlayer(el);

        var self = this;

       this.oUPlayer.onActive = function(){if(self.onActive) self.onActive.call(self.oUPlayer)}
        this.oUPlayer.onDisableActive = function(){if(self.onDisableActive) self.onDisableActive.call(self.oUPlayer)}

        this.status = 'loaded';
    }

    del(){
        if(this.oUPlayer) this.oUPlayer.del();
        else this.status = 'notload';
    }
}

export {UPlayerWrapper};




































